import { render, staticRenderFns } from "./dermatology.vue?vue&type=template&id=f917d6b2&scoped=true&"
import script from "./dermatology.vue?vue&type=script&lang=js&"
export * from "./dermatology.vue?vue&type=script&lang=js&"
import style0 from "./dermatology.vue?vue&type=style&index=0&id=f917d6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f917d6b2",
  null
  
)

export default component.exports